import type * as ToggleGroup from '@radix-ui/react-toggle-group';
import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../utils';

import { RadioToggleGroupIcon, RadioToggleGroupItem } from './RadioToggleGroup';

export const CardToggleGroupItem = forwardRef<
  HTMLButtonElement,
  ToggleGroup.ToggleGroupItemProps
>(({ className, ...props }, ref) => {
  return (
    <RadioToggleGroupItem
      className={cn(
        'relative overflow-hidden flex flex-col gap-2 basis-0 grow items-start rounded-md p-4 text-grey-80 hover:bg-grey-1 hover:text-black hover:cursor-pointer border border-grey-10',
        'data-[state=on]:border data-[state=on]:border-primary-100 data-[state=on]:bg-primary-5 data-[state=on]:text-black',
        className,
      )}
      {...props}
      ref={ref}
    />
  );
});

export const CardToggleGroupItemHeader = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex flex-row items-center gap-2 font-extrabold',
        className,
      )}
      {...props}
    >
      <RadioToggleGroupIcon />
      {children}
    </div>
  );
});

export const CardToggleGroupItemDescription = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <p className={cn('text-left font-light', className)} {...props} ref={ref}>
      {children}
    </p>
  );
});
